<wbo-select-option [value]="KvdDocketTimerType.ORDER" label="wbo.order-processor.edit.option.kvdDocketTimerType.order">
</wbo-select-option>
<wbo-select-option [value]="KvdDocketTimerType.DISPLAY" label="wbo.order-processor.edit.option.kvdDocketTimerType.display">
</wbo-select-option>
